import affiliateLandingPage from './affiliate_landing_page_animation.lottie.json';
import individualLandingPage from './individual_landing_page_animation.lottie.json';
import successPage from './success_page_animation.lottie.json';

/** `op` is the out point (last frame); callers read it to play segments. */
export type LottieAnimation = {
  op: number;
};

// tsgo emits no declaration for a `.json` input, so re-exporting these from
// the package entry fails dts generation. Annotating them here keeps the JSON
// out of the declaration graph.
export const affiliateLandingPageAnimation: LottieAnimation =
  affiliateLandingPage;

export const individualLandingPageAnimation: LottieAnimation =
  individualLandingPage;

export const successPageAnimation: LottieAnimation = successPage;
